var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import PurBackService from '../../api/PurBackService';
import Header from './component/DetailHeader.vue';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.rowId = '';
        _this.formData = {};
        _this.data = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = PurBackService.getInstance();
        this.getDetail();
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 370;
        }, 300);
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
        };
        this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.formData = data;
            _this.data = data.items || [];
            _this.data.map(function (item, index) {
                if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                    item.children = [item.order_goods_replace];
                }
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1 = __decorate([
        Component({
            components: {
                'add-header': Header,
            },
            computed: {
                isHideGiftAmount: function () {
                    var billData = this.formData || {};
                    return (billData.logistics_type === 2 && billData.depot_in_model === 1) || [4, 5].includes(billData.logistics_type);
                },
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
